import {
  capitalize,
  deriveSentimentDrivers,
  pct,
  valenceLabel,
} from '../sentimentDrivers.helpers';

interface Props {
  /** `pr.emotion_detection.emotion_scores` — Apollo-stamped, possibly partial. */
  emotionScores: Record<string, unknown> | null | undefined;
}

/**
 * Explains the dominant sentiment by mapping emotion scores to a valence pole:
 * "Negative — driven by Anger 98%, traces of fear/sadness."
 *
 * Renders nothing when no valence-bearing emotion is present (graceful gate).
 * Inner content only; lives directly under the SentimentBar in the same section.
 */
export default function SentimentDrivers({ emotionScores }: Props) {
  const drivers = deriveSentimentDrivers(emotionScores);
  if (!drivers) return null;

  const { valence, dominant, traces } = drivers;
  const valenceClass = `POST__ANALYSIS__drivers__valence--${valence}`;

  return (
    <p className="POST__ANALYSIS__drivers">
      <span className={`POST__ANALYSIS__drivers__valence ${valenceClass}`}>
        {valenceLabel(valence)}
      </span>{' '}
      — driven by{' '}
      <strong className="POST__ANALYSIS__drivers__dominant">
        {capitalize(dominant.emotion)} {pct(dominant.score)}
      </strong>
      {traces.length > 0 && (
        <>, traces of {traces.map((t) => t.emotion).join('/')}</>
      )}
      .
    </p>
  );
}
